import { makeStyles } from 'tss-react/mui'

const noSearchResultsStyles = makeStyles()((theme) => ({
  gridWrapper: {
    overflow: 'hidden',
    padding: 0,
    paddingTop: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
  columnWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.up('lg')]: {
      paddingRight: theme.spacing(5),
    },
  },
  firstColumn: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '66%',
    },
  },
}))

export default noSearchResultsStyles
